import { Box, Typography, Grid } from '@mui/material';
import { useState } from 'react';
import {
  businessDetailsSectionTitleSx,
  businessDetailsSectionSubtitleSx
} from '../../styles/createCampaign';
import { Input } from 'src/components/UI/Input';
import { DatePickerInput } from 'src/components/UI/DatePickerInput';
import { Controller, useFormContext } from 'react-hook-form';
import { ConfirmAndPayFormData } from './index';

export const BusinessLocationContactInfo = () => {
  const {
    control,
    formState: { errors }
  } = useFormContext<ConfirmAndPayFormData>();
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  return (
    <Box>
      <Typography sx={businessDetailsSectionTitleSx}>
        Business Location Contact Info
      </Typography>

      <Typography sx={businessDetailsSectionSubtitleSx}>
        This information will appear on your chosen citations. People will use
        these details to contact the business location directly.
      </Typography>

      <Grid container spacing={{ xs: 1.5, sm: 2 }}>
        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationContactInfo.contactFirstName"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Contact First Name"
                fullWidth
                placeholder="Enter Name"
                error={!!errors.businessLocationContactInfo?.contactFirstName}
                helperText={errors.businessLocationContactInfo?.contactFirstName?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationContactInfo.contactLastName"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Contact Last Name"
                fullWidth
                placeholder="Enter Here"
                error={!!errors.businessLocationContactInfo?.contactLastName}
                helperText={errors.businessLocationContactInfo?.contactLastName?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationContactInfo.contactEmail"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Contact Email"
                fullWidth
                placeholder="Enter Here"
                type="email"
                error={!!errors.businessLocationContactInfo?.contactEmail}
                helperText={errors.businessLocationContactInfo?.contactEmail?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationContactInfo.contactPhoneNumber"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Contact Phone Number"
                fullWidth
                placeholder="Enter Here"
                error={!!errors.businessLocationContactInfo?.contactPhoneNumber}
                helperText={errors.businessLocationContactInfo?.contactPhoneNumber?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationContactInfo.faxNumber"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Fax Number"
                fullWidth
                placeholder="Enter Here"
                error={!!errors.businessLocationContactInfo?.faxNumber}
                helperText={errors.businessLocationContactInfo?.faxNumber?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationContactInfo.openingDate"
            control={control}
            render={({ field }) => (
              <DatePickerInput
                label="Opening Date"
                value={field.value || null}
                onChange={(date) => field.onChange(date)}
                isOpen={isDatePickerOpen}
                onOpen={() => setIsDatePickerOpen(true)}
                onClose={() => setIsDatePickerOpen(false)}
                error={!!errors.businessLocationContactInfo?.openingDate}
                helperText={errors.businessLocationContactInfo?.openingDate?.message as string | undefined}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
